module.exports = __webpack_public_path__ + "img/logo.2be068f2.png";